// Define flags
export const DEFAULT_CHANNEL = true;
export const DEFAULT_CHANNEL_VALUE = 1;
export const MULTIPLE_CAT_PER_VIDEO = false;
export const SHOW_OVERVIEW_DASHBOARD = true;
export const SHOW_ADMIN_USERS = false;
export const SHOW_CONTENT_CATEGORIES = true;
export const SUBCONTENT_CATEGORIES = true;
export const SHOW_CONTENT_VIDEOS = true;
export const SHOW_TABS = true;
export const SHOW_REPORTS_OVERVIEW_VIDEOS = true;
export const SHOW_REPORTS_OVERVIEW_ADS = true;
export const SHOW_REPORTS_ENGAGEMENT = true;
export const SHOW_CONTACTS = true;
export const SHOW_LANGUAGES = true;
export const SHOW_RESOURCES = true;
export const SHOW_BULK_EMAIL = true;

// Define commonly used constants
export const LS_ADMIN_USER_AUTH_TOKEN = '__tcls_admin_t';
export const LS_ADMIN_USER_NAME = '__tcls_admin_n';
export const LS_ADMIN_USER_EMAIL = '__tcls_admin_e';
export const LS_ADMIN_USER_ROLE = '__tcls_admin_r';

export const STATUS_LABELS = {
  0: 'Inactive',
  1: 'Active',
  2: 'Deleted',
  5: 'Requested Delete',
  11: 'Pending Verification',
  12: 'Cancellation Applied',
};

export const CONTACT_STATUS_LABELS = {
  0: 'Unsubscribed',
  1: 'Subscribed',
};

export const MP3_STATUS_LABELS = {
  0: 'Not Started',
  1: 'In Progress',
  2: 'Completed',
};

export const STATUS_COLORS = {
  0: 'error',
  1: 'success',
  2: 'error',
  5: 'warning',
  11: 'warning',
  12: 'warning',
};

export const CONTACT_STATUS_COLORS = {
  0: 'warning',
  1: 'success',
};

export const MP3_STATUS_COLORS = {
  0: 'error',
  1: 'warning',
  2: 'success',
};

export const CONTENT_ALIAS = {
  CHANNEL_SINGULAR: 'Channel',
  CHANNEL_PLURAL: 'Channels',
  CATEGORY_SINGULAR: 'Book',
  CATEGORY_PLURAL: 'Books',
  VIDEO_SINGULAR: 'Lesson',
  VIDEO_PLURAL: 'Lessons',
  AD_SINGULAR: 'Ad',
  AD_PLURAL: 'Ads',
};

export const CATEGORY_OPTIONS = {
  old: {
    shorthand: 'old',
    title: 'OLD TESTAMENT STUDY',
    displayText: 'Old Testament',
    path: 'old',
  },
  new: {
    shorthand: 'new',
    title: 'NEW TESTAMENT STUDY',
    displayText: 'New Testament',
    path: 'new',
  },
};

export const ACTIONS = {
  CREATE: {
    value: 'create',
    label: 'Create New',
  },
  WPEDIT: {
    value: 'wpupdate',
    label: 'WP Edit',
  },
  EDIT: {
    value: 'update',
    label: 'Edit',
  },
  TRANSLATE: {
    value: 'translate',
    label: 'Translate',
  },
  VIEW: {
    value: 'view',
    label: 'View',
  },
  DELETE: {
    value: 'delete',
    label: 'Delete',
  },
  CHANGE_PASSWORD: {
    value: 'change_password',
    label: 'Change Password',
  },
  ASSIGN_CATEGORIES: {
    value: 'assign_books',
    label: `Assign ${CONTENT_ALIAS.CATEGORY_PLURAL}`,
  },
  UPLOAD_MP4: {
    value: 'upload_mp4',
    label: 'Upload Video (MP4)',
  },
  UPLOAD_ASSETS: {
    value: 'upload_assets',
    label: 'Upload Audio & Other Assets',
  },
  DOWNLOAD: {
    value: 'download',
    label: 'Download',
  },
  COPY: {
    value: 'copy',
    label: 'Copy',
  },
};

export const SESSION_TYPE = {
  video: 'Video',
  audio: 'Audio',
};

export const ASSET_TYPE = {
  SLIDES: {
    value: 'SLIDES',
    label: 'Slides (PDF)',
    icon: 'proicons:pdf',
  },
  PODCAST: {
    value: 'PODCAST',
    label: 'Audio (MP3)',
    icon: 'ic:outline-audio-file',
  },
  TRANSCRIPT_PDF: {
    value: 'TRANSCRIPT',
    label: 'Transcript (PDF)',
    icon: 'mdi:file-document-outline',
  },
  TRANSCRIPT_DOCX: {
    value: 'TRANSCRIPT-DOCX',
    label: 'Transcript (Docx)',
    icon: 'tabler:file-type-docx',
  },
};

export const DEFAULT_FEATURED_LESSON_ID = 377;

// Place it in CSS file
export const FOCUS_PALETTE_BGCOLOR = 'rgba(255, 255, 255, 0.25)';

export const EMAIL_PLACEHOLDERS = [
  { value: 'first_name', label: 'First Name' },
  { value: 'last_name', label: 'Last Name' },
  { value: 'email', label: 'Email' },
];

export const RESOURCE_TYPE = {
  PDF: { label: 'PDF', value: 'PDF' },
};

export const EMAIL_CAMPAIGNS_STATUS = {
  QUEUED: { label: 'Queued', value: 'QUEUED', color: 'primary' },
  SENDING: { label: 'Sending', value: 'SENDING', color: 'warning' },
  COMPLETED: { label: 'Completed', value: 'COMPLETED', color: 'success' },
  FAILED: { label: 'Failed', value: 'FAILED', color: 'error' },
};

export const EMAIL_CAMPAIGN_RECIPIENTS_STATUS = {
  PENDING: { label: 'Pending', value: 'PENDING', color: 'primary' },
  PROCESSING: { label: 'Processing', value: 'PROCESSING', color: 'warning' },
  SENT: { label: 'Sent', value: 'SENT', color: 'success' },
  FAILED: { label: 'Failed', value: 'FAILED', color: 'error' },
};
